import { useDispatch, useSelector } from "react-redux";
import { ProcedureRow } from "types/CreateOrder";

import { buildSelectedProceduresObject } from "../../builders";
import { autoCompleteHandleRemoveProcedure } from "../../handlers";
import { StyledTrashButton } from "./styled";

interface IRemoveItem {
  row: ProcedureRow;
  autoCompleteValue: string[];
}
export function RemoveItem({ row, autoCompleteValue }: IRemoveItem) {
  const dispatch = useDispatch();
  const rows = useSelector((state: any) => state.serviceDetailsSlice.rows);

  return (
    <StyledTrashButton
      aria-label="Remove service"
      icon="pi pi-trash"
      className="p-button-text p-button-rounded"
      onClick={() =>
        autoCompleteHandleRemoveProcedure({
          selectedRow: row,
          rows,
          selectedProceduresObject:
            buildSelectedProceduresObject(autoCompleteValue),
          dispatch,
        })
      }
    />
  );
}
